<!--
 * @Author: Merlin
 * @Date: 2024-07-16 13:33:43
 * @LastEditors: Gaho
 * @LastEditTime: 2024-12-09 16:04:16
 * @Description: 
-->
<template>
    <div v-if="show"
        class="rounded-xl py-4 inset-x-0 bg-[#1c2532] z-10"
    >
        <div class="overflow-auto gap-5 flex relative">
            <div
                class="flex w-full line2 [&>*:nth-child(2)]:pl-5"
                v-for="(value, key) in exChangeRateCurrenciesComputed"
                :key="key"
            >
                <div class="flex-1 items-center flex gap-2 sm:block">
                    <ModalRulesLimitComponentRateCoin :name="key" />
                    <span class="font-semibold">
                        {{ getMinBet(key) }}
                    </span>
                </div>
                <div class="flex-1 items-center flex gap-2 sm:block">
                    <ModalRulesLimitComponentRateCoin :name="key" />
                    <span class="font-semibold">
                        {{ getMaxBet(key) }}
                    </span>
                </div>
            </div>
        </div>
    </div>
</template>

<script lang="ts" setup>
import useTranslation from '~/i18n/useTransLation';
import { useJoinStateStore } from '~/stores/cansino/joinState';
import { useRatesStore } from '~/stores/cansino/rates';
import { prefixIsUsdtRegxp } from '~/utils/regxp';

const t = useTranslation();
const ratesStore = useRatesStore();
const joinStateStore = useJoinStateStore();
const props = defineProps({
    show: {
        type: Boolean,
        default: false,
    },
});

const exChangeRateCurrenciesComputed = computed(() => {
    return ratesStore.usdtComaparisonCurrencyList;
});

const getMaxBet = (key: string) => {
    const currency = key.replace(prefixIsUsdtRegxp, '');
    const fValue = extractMaxBets(joinStateStore.config[currency]);
    return number2LocaleString(fValue);
};

const extractMaxBets = (configObj) => {
    const {sectors, maxBets} = configObj || {};
    // ↓ circle 游戏专有配置信息
    if (sectors){
        const arr = Object.values(sectors).map(cur=>{
            return cur['maxBetAmount'];
        });
        return Math.max(...arr);
    }
    if (maxBets) {
        if (typeof maxBets == 'number') return maxBets;
        const allValuesSame = Object.values(maxBets).every((val) => {
            return val === maxBets[0];
        });

        // 如果數組中所有值都是相同的話，回傳第一個
        if (allValuesSame) return maxBets[1];
        // 如果有default值，回傳default
        if (maxBets.default) {
            return maxBets.default;
        }
        // 如果沒有default值，回傳param index
        maxBets[1];
    }
};

const getMinBet = (key: string) => {
    const currency = key.replace(prefixIsUsdtRegxp, '');
    let {sectors, minBetAmount } = joinStateStore.config[currency];
    // ↓ circle 游戏专有配置信息
    if (sectors){
        // console.log('sectors', deepCopy(sectors));
        const arr = Object.values(sectors).map(cur=>{
            return cur['minBetAmount'];
        });
        minBetAmount = Math.min(...arr); 
    }
    return number2LocaleString(minBetAmount);
};
</script>

<style lang="scss" scoped>
/* ↑ 补一个 scoped 2024.07.16 9:42:56 星期二  */

.line2::before {
    content: '';
    position: absolute;
    left: 49%;
    top: 0px;
    bottom: 0;
    width: 1px;
    background: #3c485c;
    transform: translate(-50%);
}
</style>
